import classNames from 'classnames';
import { FC } from 'react';

interface LinkFieldProps {
  className: string;
  url?: string;

  code?: string;
}

export const LinkField: FC<LinkFieldProps> = ({ url, code, className }) => {
  if (url === undefined || code === undefined) {
    return null;
  }

  return (
    <a href={url} className={classNames('text-link', className)} target="_blank">
      {code}
      <em className="icon icon-sm ms-2">launch</em>
    </a>
  );
};
